"use client";
import React, { useState } from "react";
import { Accordion, HStack, Center, Icon } from "@chakra-ui/react";
import { Text } from "@/elements";
import { FaMinus, FaPlus } from "@onemind-services-llc/react-icons-ng/fa";

export type AccordionProps = {
  title: string;
  content: React.ReactNode;
};

const AccordionComponent = (props: AccordionProps) => {
  const { content, title } = props;
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Accordion.Root
      collapsible
      onValueChange={(details) => {
        setIsExpanded(details.value.includes(title));
      }}
    >
      <Accordion.Item
        value={title}
        borderColor={"#ccc"}
        borderRadius={"8px"}
        borderWidth={"1px"}
        p={"7px 15px 7px 14px"}
      >
        <Accordion.ItemTrigger _hover={{ cursor: "pointer" }}>
          <HStack justify={"space-between"} width={"full"}>
            <Text fontWeight={500} textAlign={"left"} variant={"body2"}>
              {title}
            </Text>
            <Center bg={"#6ec1e4"} borderRadius={"50%"} height={"25px"} width={"25px"}>
              <Icon
                as={isExpanded ? FaMinus : FaPlus}
                color={"whiteAlpha.900"}
                fontSize={isExpanded ? "20px" : "18px"}
                maxWidth={"25px"}
                minWidth={"25px"}
              />
            </Center>
          </HStack>
        </Accordion.ItemTrigger>
        <Accordion.ItemContent pt={2}>
          <Accordion.ItemBody>
            {typeof content === "string" ? (
              <Text variant={"body2"} color="text.100" whiteSpace={"pre-line"}>
                {content}
              </Text>
            ) : (
              content
            )}
          </Accordion.ItemBody>
        </Accordion.ItemContent>
      </Accordion.Item>
    </Accordion.Root>
  );
};

export default AccordionComponent;

// const ButtonComponent = (props: {isExpanded: boolean; title: string}) => {
//   const {isExpanded, title} = props;
//   return (
//     <AccordionButton _hover={{}}>
//       <HStack justify={"space-between"} w={"full"}>
//         <Text fontWeight={500} textAlign={"left"} variant={"body2"}>
//           {title}
//         </Text>
//         <Center bg={"#6ec1e4"} borderRadius={"50%"} h={"25px"} w={"25px"}>
//           <Icon
//             as={isExpanded ? FaMinus : FaPlus}
//             color={"whiteAlpha.900"}
//             fontSize={isExpanded ? "20px" : "18px"}
//             maxW={"25px"}
//             minW={"25px"}
//           />
//         </Center>
//       </HStack>
//     </AccordionButton>
//   );
// };

// const AccordionComponent = (props: AccordionComponentProps) => {
//   const {items} = props;
//   return (
//     <Accordion.Root collapsible>
//       {items.map((item, index) => (
//         <Accordion.Item
//           key={index}
//           value={item.value}
//           borderColor={"#ccc"}
//           borderRadius={"8px"}
//           borderWidth={"1px"}
//           p={"7px 7px 7px 0"}
//         >
//           <Accordion.ItemTrigger>
//             {item.title}
//             <Accordion.ItemIndicator />
//           </Accordion.ItemTrigger>
//           <Accordion.ItemContent>
//             <Accordion.ItemBody>{item.content}</Accordion.ItemBody>
//           </Accordion.ItemContent>
//         </Accordion.Item>
//       ))}
//     </Accordion.Root>
//   );
// };

// export default AccordionComponent;
